import React from "react";
import { Skeleton, Box } from "@mui/material";
import styles from "./TableViewv2/styles.module.css";

const TableSkeleton = ({ columns = [], rows = 5, hasBotoes = false }) => {
  // Se não tiver colunas definidas, cria colunas padrão baseadas na estrutura comum
  const defaultColumns = columns.length > 0 
    ? columns 
    : [
        { key: "col1", label: "Coluna 1", width: "150px" },
        { key: "col2", label: "Coluna 2", width: "150px" },
        { key: "col3", label: "Coluna 3", width: "150px" },
        { key: "col4", label: "Coluna 4", width: "150px" },
      ];

  return (
    <table className={styles.table}>
        <thead>
          <tr>
            {defaultColumns.map((col, i) => {
              const headerStyle = col.width 
                ? { width: col.width, minWidth: col.width, maxWidth: col.width }
                : {};
              
              return (
                <th 
                  key={i} 
                  className={styles.columns} 
                  style={headerStyle}
                >
                  <Skeleton 
                    variant="text" 
                    width="60%" 
                    height={20}
                    sx={{ mx: "auto" }}
                  />
                </th>
              );
            })}
            {hasBotoes && (
              <th
                className={`${styles.colunaAcoes} ${styles.colunaAcoesIcones}`}
                style={{ textAlign: "center" }}
              >
                <Skeleton
                  variant="text"
                  width="60%"
                  height={20}
                  sx={{ mx: "auto" }}
                />
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <tr key={rowIndex} className={styles.tableBody}>
              {defaultColumns.map((col, colIndex) => {
                const cellStyle = col.width 
                  ? { width: col.width, minWidth: col.width, maxWidth: col.width }
                  : {};
                
                return (
                  <td 
                    key={colIndex} 
                    style={cellStyle}
                  >
                    <Skeleton 
                      variant="text" 
                      width={colIndex === 0 ? "80%" : "60%"}
                      height={24}
                    />
                  </td>
                );
              })}
              {hasBotoes && (
                <td
                  className={`${styles.colunaAcoes} ${styles.colunaAcoesIcones}`}
                  style={{ textAlign: "center" }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      gap: 0.25,
                    }}
                  >
                    <Skeleton variant="circular" width={30} height={30} />
                    <Skeleton variant="circular" width={30} height={30} />
                    <Skeleton variant="circular" width={30} height={30} />
                  </Box>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
  );
};

export default TableSkeleton;
